import React from 'react'

const Contact = (props) => {

    return (
        <div id='Contact '>
            <div className= "contactContainer">
           
                <button id="closeButton" type="button" class="btn-close" aria-label="Close" onClick={props.closeContactMe}></button>

                
            <ul className="social-icons">
              
              <li><a className="mail" href="mailto:caroescalacumbres@gmail.com" target="_blank"><i className="bi bi-envelope-fill"></i></a></li>

              <li><a className="whatsapp" href="https://wa.me/+5491123943557" target="_blank"><i className="bi bi-whatsapp"></i></a></li>

              <li><a className="github" href="https://github.com/caro-escala?tab=repositories" target="_blank"><i className="bi bi-github"></i></a></li> 

              <li><a className="linkedin" href="https://www.linkedin.com/in/carolina-andrea-m%C3%B6ller-671b2a21/" target="_blank"><i className="bi bi-linkedin"></i></a></li> 

              <li><a className="instagram" href="https://www.instagram.com/caro_escala/" target="_blank"><i className="bi bi-instagram"></i></a></li>

              <li><a className="facebook" href="https://www.facebook.com/carolinaandrea.moller/" target="_blank"><i className="bi bi-facebook"></i></a></li>

            </ul>
          </div>

    </div>
    )
}

export default Contact